<template>
  <div>
    <AppBackdrop />
    <AppVideoModal />
    <AppImageModal />
    <!-- <AppCertificateModal />
    <AppBusinessContactModal /> -->
  </div>
</template>

<script>
  import AppBackdrop from './AppBackdrop.vue'
  import AppVideoModal from './AppVideoModal.vue'
  import AppImageModal from './AppImageModal.vue'
  // import AppCertificateModal from '../Molecules/AppCertificateModal.vue'
  // import AppBusinessContactModal from '../Molecules/AppBusinessContactModal.vue'

  export default {
    name: 'AppActions',
    components: {
      AppBackdrop,
      AppVideoModal,
      AppImageModal,
      // AppCertificateModal,
      // AppBusinessContactModal,
    },
  }
</script>
